import { useEffect, useState } from "react";
import { api } from "../../lib/api";

export default function Horarios() {
  const [body, setBody] = useState("");
  useEffect(() => {
    api.get("/content/horarios").then((r) => setBody(r.data.data?.body || ""));
  }, []);
  return (
    <div className="space-y-6 animate-in fade-in duration-500" data-testid="horarios-page">
      <header className="py-4">
        <div className="text-xs uppercase tracking-[0.25em] text-primary font-bold">Horarios</div>
        <h1 className="font-display font-black text-4xl sm:text-5xl mt-1">Cuándo te esperamos</h1>
      </header>
      <div className="bg-white rounded-2xl border border-border p-6 whitespace-pre-line text-base leading-relaxed" data-testid="horarios-body">
        {body}
      </div>
    </div>
  );
}
